import { accordionAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const helpers = createMultiStyleConfigHelpers(accordionAnatomy.keys);

const bootstrap = helpers.definePartsStyle(({
    container: {
        border: 'none',
    },
    panel: {
        padding: 5,
        borderTopRadius: 0,
        borderBottomRadius: 'md',
        border: '1px solid',
        borderTop: 'none',
        borderColor: 'muted.50',
        backgroundColor: 'white',
        _expanded: {
            borderBottomRadius: 0,
        },
    },
    button: {
        cursor: 'pointer',
        gap: 0,
        py: 4,
        rounded: 'md',
        bg: 'muted.25',
        border: '1px',
        borderColor: 'muted.50',
        _expanded: {
            borderBottomRadius: 0,
        },
        _hover: {
            bg: 'muted.25',
        },
    },
}));

export const accordionTheme = helpers.defineMultiStyleConfig({
    variants: { bootstrap },
});
